import { useAppleStatusQuery } from 'apollo/queries/autogenerate/hooks';
import { AppleCreditStatus } from 'apollo/queries/autogenerate/schemas';
import useIsPlusUser from 'utils/hooks/use-is-plus-user';

export default function useIsPlusWithApple() {
  const { data: appleStatus } = useAppleStatusQuery({
    fetchPolicy: 'network-only',
  });

  const isPlusUser = useIsPlusUser();

  const isAppleApproved =
    appleStatus?.appleCreditStatus.status === AppleCreditStatus.APPROVED;

  return isPlusUser && isAppleApproved;
}
